<template lang="">
  <div>
        <my-header color='#fff'></my-header>
        <img class="bg bg1" src="https://static.lespark.cn/pc_img/images/baihua/bg1.png" alt="">
        <img class="bg bg2" src="https://static.lespark.cn/pc_img/images/baihua/bg2.png" alt="">
        <img class="bg bg3" src="https://static.lespark.cn/pc_img/images/baihua/bg3.png" alt="">
        <img v-for='img,imgClass in imgJb' :src="img" alt="" :class="imgClass" v-if="imgClass!='j5'" class="jb">
        <div class="content">
        <img v-show="!isLogo"src="https://static.lespark.cn/pc_img/images/baihua/logo.png" alt="" class="logo-baihua">
        <div v-show="isLogo" class="logo-baihua" id="logoBaihua" ref="logoBaihua"></div>
        <div class="svgaTitle">
          <div v-show="!isTitle" id="titleSvga"></div>
          <img v-show="isTitle" class="bg1-title" :src="$t('baiHuaTxt.bg1Title')" alt="">
        </div>
        <div class="bg1-award" :class="{'award-ani':isAni}">
          <div v-for="award,awardIndex in $t('baiHuaTxt.award')">{{ award }}</div>
        </div>
        <div class="bg1-tips">{{ $t("baiHuaTxt.bg1Tips") }}</div>
        <div class="bg1-tips2">{{ $t("baiHuaTxt.bg1Tips2") }}</div>
        <div class="rule" @click="goRule()" style="cursor: pointer;">{{ $t("baiHuaTxt.rule") }} ></div>
        <div class="bg2-title">{{ $t("baiHuaTxt.bg2Title") }}</div>
        <div class="bg2-tips">
          <p v-html="bg2Tips[0]"></p>
          <div v-html="bg2Tips[1]"></div>
          <p v-html="bg2Tips[2]" style="margin-left: 24px;"></p>
          <div v-html="bg2Tips[3]"></div>
          <p v-html="bg2Tips[4]" style="margin-left: 24px;"></p>
        </div>
          <div class="bg2-img ani2">
            <img :src="$t('baiHuaTxt.bg2Img')" alt="">
          </div>
         <div class="bg2-tips2">{{ $t("baiHuaTxt.bg2Tips2") }}</div>
         <div class="bg2-tips3">{{ $t("baiHuaTxt.bg2Tips3") }}</div>
         <div class="bg3-title">{{ $t("baiHuaTxt.bg3Title") }}</div>
         <div class="bg3-tips">
          <p v-html="bg3Tips[0]"></p>
          <div v-html="bg3Tips[1]"></div>
          <p v-html="bg3Tips[2]"></p>
         </div>
         <div class="bg3-img">
          <img v-show="!isTq" :src="$t('baiHuaTxt.bg3Img')"  alt="">
          <div v-show="isTq" id="tq"></div>
         </div>
         <div class="bg3-tips2">
          {{ $t("baiHuaTxt.bg3Tips2") }}
          <span @click="goRule()"  style="cursor: pointer;">{{ $t("baiHuaTxt.rule") }} ></span>
         </div>
         <div class="bg3-tips2">{{ $t("baiHuaTxt.bg3Tips3") }}</div>
         <div class="bg3-tips2">{{ $t("baiHuaTxt.bg3Tips4") }}</div>
        </div>
        <my-footer></my-footer>
  </div>


</template>
<script>
import Vue from "vue";
import constans from "Constans";
import Utils from "Common/util";
import cookie from "Common/cookie";
import myHeader from "Views/components/header";
import myFooter from "Views/components/foot";
import VueMeta from "vue-meta";
import { Icon } from "vant";
import SVGA from "svgaplayerweb";

Vue.use(VueMeta);
Vue.use(Icon);
const userUrl = constans.AllUrl.url.dev;
export default {
  name: "app",
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      hotOnlineList: [],
      canonicalUrl: "",
      title: "",
      desc: "",
      logo: "https://static.lespark.cn/pc_img/images/baihua/logo.svga",
      imgJb:{
        j1:"https://static.lespark.cn/pc_img/images/baihua/j1.png",
        j2:"https://static.lespark.cn/pc_img/images/baihua/j2.png",
        j3:"https://static.lespark.cn/pc_img/images/baihua/j3.png",
        j4:"https://static.lespark.cn/pc_img/images/baihua/j4.png",
        j5:"https://static.lespark.cn/pc_img/images/baihua/j5.png",
        j6:"https://static.lespark.cn/pc_img/images/baihua/j6.png",
      },
      isTq:false,
      isLogo:false,
      isAni:false,
      isTitle:false,
      bg2Tips:[],
      bg3Tips:[],
    };
  },
  props: {
    color: {
      type: String,
      default: "#fff"
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.desc
        }
      ],
      link: [
        {
          ref: "canonical",
          href: this.canonicalUrl
        }
      ]
    };
  },
  created() {
    const that = this;
    let _arg = Utils.getQueryStringArgs();
    const language = cookie.getCookie("language");
    if (Utils.getLang() =='cn' || _arg.lang == "zh-Hans-TW" || language == "简体中文") {
      that.canonicalUrl = "https://www.lespark.cn/help.html?lang=zh-Hant-TW";
      that.title = "LesPark";
      that.desc = "LesPark汇集了众多有趣、有颜、有才的女性主播，您可以实时登陆观看热门直播的精彩视频，LesPark可满足您对于观看高颜值直播、视频交友等多种需求。";
    } else if (Utils.getLang() =='en' || _arg.lang == "en" || language == "English") {
      that.canonicalUrl = "https://www.lespark.cn/help.html?lang=en";
      that.title = "LesPark";
      that.desc = "LesPark is a collection of popular topics of interest to lesbians, where you can interact with women from all over the world.";
    } else {
      that.canonicalUrl = "https://www.lespark.cn/help.html";
      that.title = "LesPark";
      that.desc = "LesPark匯集了眾多有趣、有顏、有才的女性主播，您可以實時登陸觀看熱門直播的精彩視頻，LesPark可滿足您對於觀看高顏值直播、視頻交友等多種需求。";
    }
  },
  mounted() {
    const that = this;
    this.logoSvga();
    this.tqSvga();
    this.titleSvga();
    that.bg2Tips = that.$t("baiHuaTxt.bg2Tips")
    that.bg3Tips = that.$t("baiHuaTxt.bg3Tips")
    that.isAni = true
  },
  methods: {
    goRule(){
      window.location.href = '/baihuaRule.html'
    },
    logoSvga() {
      const that = this;
      var mycanvas = document.getElementById("logoBaihua");
      let player = new SVGA.Player("#logoBaihua");
      let parser = new SVGA.Parser("#logoBaihua");
      // this.imageUrl 定义一个参数接收url
      parser.load(this.logo, function(videoItem) {
        player.setVideoItem(videoItem);
        player.startAnimation(
          setTimeout(()=>{
            that.isLogo = true
          },1000)
       );
      });
    },
    tqSvga() {
      const that = this;
      var mycanvas = document.getElementById('tq')
      let player = new SVGA.Player("#tq");
      let parser = new SVGA.Parser("#tq");
      // this.imageUrl 定义一个参数接收url
      parser.load(this.$t('baiHuaTxt.tqSvga'), function(videoItem) {
        player.setVideoItem(videoItem);
        player.startAnimation(
            setTimeout(()=>{
              that.isTq = true
            },1000)
        );
      });
    },
    titleSvga() {
      const that = this;
      var mycanvas = document.getElementById('titleSvga')
      let player = new SVGA.Player("#titleSvga");
      let parser = new SVGA.Parser("#titleSvga");
      // this.imageUrl 定义一个参数接收url
      parser.load(this.$t('baiHuaTxt.titleSvga'), function(videoItem) {
        player.setVideoItem(videoItem);
        player.startAnimation(
            setTimeout(()=>{that.isTitle = true},2000)
        );
      });
    },
  }
};

</script>
<style>
body{
  width: 100vw;
  overflow-x: hidden;
}
</style>
<style lang="" scoped>
.content {
  max-width: 1400px;
  min-width: 960px;
  width: 90%;
  position: relative;
  margin: 0 auto 130px;
  text-align: center;
}

.jb{
  position: absolute;
}

.bg {
  width: 100vw;
  position: absolute;
  height: 1080px;
}

.bg1 {
  top: 0;
}

.bg2 {
  top: 1080px;
}

.bg3 {
  top: 2160px;
}

.logo-baihua {
  width: 160px;
  height: 160px;
  margin: 53px auto 0;
  display: block;
}

.bg1-title {
  width: 750px;
  height: 200px;
  display: block;
  margin:  0 auto;
}

.bg1-award {
  margin-bottom: 24px;
}

.bg1-award, .bg1-award div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg1-award div {
  width: 103px;
  height: 103px;
  background: url(https://static.lespark.cn/pc_img/images/baihua/award-bg.png);
  background-size: 100% 100%;
  font-size: 60px;
  font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
  font-weight: 800;
  color: #FFF7EC;
  margin-left: 14px;
}

.bg1-award div:nth-last-of-type(1) {
  margin-right: 0;
}

.bg1-tips {
  height: 65px;
  font-size: 46px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 65px;
  margin-bottom: 107px;
  opacity: 0.8;
}

.bg1-tips2 {
  max-width: 1000px;
  min-width: 400px;
  height: 42px;
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  margin-bottom: 59px;
  margin: 0 auto 59px;
  opacity: .7;
}

.rule {
  height: 17px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FCD5BF;
  line-height: 17px;
  margin-bottom: 259px;
}

.bg2-title {
  height: 65px;
  font-size: 46px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 65px;
  margin-bottom: 17px;
  opacity: 0.8;
}

.bg2-tips {
  height: 77px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FDE0CF;
  background: linear-gradient(270deg, #FCC59F 0%, #FDE1D0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.bg2-tips p {
  font-size: 46px;
  line-height: 46px;
}

.bg2-tips div {
  font-size: 55px;
  line-height: 55px;
}

.bg2-img {
  width: 534px;
  height: 483px;
  position: relative;
  margin: 0 auto;
}

.bg2-img > img {
  width: 534px;
  height: 536px;
  position: absolute;
  bottom: 10px;
  left: 0;
}

.bg2-tips2 {
  height: 65px;
  font-size: 46px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFD9C8;
  line-height: 65px;
  margin-bottom: 37px;
  opacity: .7;
}

.bg2-tips3 {
  height: 42px;
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 42px;
  margin-bottom: 293px;
  opacity: .7;
}

.bg3-title {
  height: 65px;
  font-size: 46px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 65px;
  margin-bottom: 17px;
  opacity: 0.8;
}

.bg3-tips {
  height: 77px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FDE0CF;
  line-height: 65px;
  background: linear-gradient(270deg, #FCC59F 0%, #FDE1D0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  opacity: .7;
}

.bg3-tips p {
  font-size: 46px;
  line-height: 46px;
}

.bg3-tips div {
  font-size: 55px;
  line-height: 55px;
}

.bg3-img {
  width: 750px;
  height: 550px;
  margin: 0 auto;
  position: relative;
}

.bg3-img > img, .bg3-img > div {
  width: 750px;
  height: 750px;
  position: absolute;
  left: 0;
  bottom: -77px;
}

.bg3-tips2 {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 33px;
  position: relative;
  opacity: .7;
}

.bg3-tips2 span {
  color: #FCD5BF;
}

.j1{
  top: -136px;
  right: 14.6875vw;
}

.j2{
  top: 578px;
  right: -72px;
}

.j3{
  top: 958px;
  left: 6.04167vw;
}

.j4{
  top:1144px;
  right:38.22917vw;
}

.j5{
  top: 1800px;
  right: 45.72917vw;
}

j6{
  top:2054px;
  left: 16.90104vw;
}
.award-ani {
  animation: awardAni 1s linear forwards;
}

@keyframes awardAni {
  0% {
    transform: scale(1);
  }
  65% {
    transform: scale(1.1);
  }
  80% {
    transform: scale(0.96);
  }
  90% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.svgaTitle,#titleSvga{
  width: 750px;
  height: 200px;
  margin: 0 auto;
}

.ani2{
  animation: shouyiIcon 2s linear infinite;
}

@keyframes shouyiIcon{
  0% {
    transform: scale(1.15);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.15);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/pages/baihua/app.vue